import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { WorkpaperType } from '@taxfyle/txf-api-client'

export type WorkpaperAssignee =
  | { readonly type: 'TAX_PAYER'; readonly id: string }
  | { readonly type: 'SPOUSE'; readonly id: string }
  | { readonly type: 'DEPENDENT'; readonly id: string }
  | { readonly type: 'BUSINESS'; readonly id: string }
  | { readonly type: 'RENTAL'; readonly id: string }
  | {
      readonly type: 'JOINT'
      readonly taxPayerId: string
      readonly spouseId: string
    }
  | { readonly type: 'UNASSIGNED' }

export type AssumedWorkpaperProps = ModelProps<AssumedWorkpaper>

export class AssumedWorkpaper extends Model<AssumedWorkpaper> {
  id = Id.none

  @observable accessor type: WorkpaperType = WorkpaperType.BalanceSheet
  @observable accessor assignedTo: WorkpaperAssignee = { type: 'UNASSIGNED' }

  toProps(): AssumedWorkpaperProps {
    return {
      id: this.id,
      type: this.type,
      assignedTo: this.assignedTo,
    }
  }
}
